import { ApiError } from './api';

/** Machine-readable server error codes → friendly Lao messages. Only codes the
 *  server returns in a `{"error":"..."}` body belong here; 500s render a generic
 *  `internal_server_error` by design, so those fall through to the caller's
 *  fallback. */
const MESSAGES: Record<string, string> = {
  main_is_child: 'ບໍລິສັດນີ້ເປັນ child ຢູ່ແລ້ວ — ສ້າງ child ຊ້ອນບໍ່ໄດ້',
  target_not_registered: 'ຖານຂໍ້ມູນເປົ້າໝາຍບໍ່ມີໃນ registry — ຕັ້ງ Main ບໍ່ໄດ້',
  too_many_attempts: 'ພະຍາຍາມຫຼາຍເກີນໄປ — ລອງໃໝ່ພາຍຫຼັງ',
  invalid_credentials: 'ຊື່ຜູ້ໃຊ້ ຫຼື ລະຫັດຜ່ານບໍ່ຖືກຕ້ອງ',
  not_found: 'ບໍ່ພົບຂໍ້ມູນ',
  tenant_not_provisioned: 'ຖານຂໍ້ມູນຂອງບໍລິສັດນີ້ບໍ່ມີແຖວ setting — ການ login ຈະບໍ່ແກ້ໃຫ້ ຕ້ອງໃຫ້ຜູ້ດູແລລະບົບແກ້ດ້ວຍມື',
  tenant_not_upgraded: 'ບໍລິສັດນີ້ຍັງບໍ່ທັນອັບເດດຖານຂໍ້ມູນ — ຕ້ອງມີຄົນ login ເຂົ້າບໍລິສັດນີ້ກ່ອນ ຈຶ່ງຈະຕັ້ງຄ່າໄດ້',
  gateway_not_writable: 'ຄ່ານີ້ບັນທຶກບໍ່ໄດ້ — ເລືອກລະບົບ TaxRIS ໃໝ່ ຫຼື ເກົ່າ ຫຼື ຕາມຄ່າລະບົບ',
  username_taken: 'ຊື່ຜູ້ໃຊ້ນີ້ມີແລ້ວ',
  already_approved: 'ໃບນີ້ອະນຸມັດແລ້ວ',
};

/** Turn a caught error into a user-facing message. Surfaces a known server
 *  error code when present; otherwise returns `fallback`. */
export function apiErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof ApiError) {
    let code: string | undefined;
    try {
      code = (JSON.parse(err.message) as { error?: string }).error;
    } catch {
      // body wasn't JSON (e.g. a proxy 502) — nothing structured to show
    }
    if (code && MESSAGES[code]) return MESSAGES[code];
  }
  return fallback;
}
